export default "__VITE_ASSET__5f9df63b__"